import Vue from 'vue'
import './plugins/fontawesome'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import layout from '@/components/template/Layout'
import ModalConfirm from '@/components/ModalConfirm'
import Mensagens from '@/components/Mensagens'

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use( CKEditor );

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import grupos from '@/mixins/userGroups.js'
Vue.mixin(grupos)

Vue.use(require('vue-moment'));

Vue.component('app-layout', layout);

Vue.component('ModalConfirm', ModalConfirm);
Vue.component('Mensagem', Mensagens);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
